import { normalizeFeatureFlags } from '@atlaskit/editor-common/normalize-feature-flags';
import type { FeatureFlags } from '@atlaskit/editor-common/types';
import type { EditorProps } from '@atlaskit/editor-core/editor';

/**
 * Transforms EditorProps's featureFlags to an normalized FeatureFlags object,
 * which is used by both current and archv3 editors.
 *
 * copied and modied from platform/packages/editor/editor-core/src/create-editor/feature-flags-from-props.ts
 */
export function createFeatureFlagsFromProps(
	featureFlags: EditorProps['featureFlags'],
): FeatureFlags {
	const normalizedFeatureFlags = normalizeFeatureFlags(featureFlags);

	return {
		...normalizedFeatureFlags,

		catchAllTracking: false,

		showAvatarGroupAsPlugin: false,

		errorBoundaryDocStructure: false,

		synchronyErrorDocStructure: false,

		enableViewUpdateSubscription: false,

		collabAvatarScroll: false,
		twoLineEditorToolbar: false,

		disableSpellcheckByBrowser: undefined,
	};
}
